import { useSelector } from 'react-redux';

export default () =>
  useSelector(({ assignment: { assignment, peopleByAssignment } }) => ({
    assignment,
    peopleByAssignment
  }));
